var $ = require('jquery');

var map = {
    currentPage: 1,
    loadedToggle: false,
    init: function(){
        map.eventHandlers();
    },
    eventHandlers: function(){ 
	    document.addEventListener('facetwp-loaded', function() {
            // only run once
            if(!map.loadedToggle){
                map.loadedToggle = true;
                map.initDays();
            }
        });               
        $(window).on('load',function(){
            if($('.block.map').length > 0){
                map.goToPage();
            }
        });
        $(window).on('hashchange', function(e) {
            if($('.block.map').length > 0){
                e.preventDefault();
                setTimeout(function(){
                    FWP_MAP.map_loaded = false;
                    FWP_MAP.init();
                    map.goToPage();
                }, 1000);
                // potential option to reload page when forward/backward in browser
                // location.reload();
            }
        });   
        $('.map-button-prev').on('click', function(e){
            e.preventDefault();
            map.prevPage();
        });
        $('.map-button-next').on('click', function(e){
            e.preventDefault();
            map.nextPage();
        }); 
        $('.toggle-inner').on('click', function(e){
            e.preventDefault();
            $(this).parents('.toolbar-flyout').siblings('.active').removeClass('active');
            $(this).parents('.toolbar-flyout').toggleClass('active');
        });
        $('.toggle-reset').on('click', function(e){
            e.preventDefault();
            $('.toolbar-flyout').removeClass('active');
            FWP.reset();
            if(history.pushState) {
                history.pushState(null, null, '#page5');
            } else {
                location.hash = '#page5';
            }            
        });
        $('.toolbar-wrapper').on('click', function(e){
            e.preventDefault();
            if($(e.target).hasClass('toolbar-wrapper')){
                $(this).parents('.toolbar-flyout').removeClass('active');
            }
        });                               
    },
    initDays: function(){
        // var days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
        // $('.facetwp-facet-available_days .facetwp-checkbox .facetwp-display-value').each(function(){

        // });
        // $.each(days, function(index, value){
        //     if($('.facetwp-facet-available_days .facetwp-checkbox[data-value|="'+value+'"]').length == 0){
        //         $('.facetwp-facet-available_days)
        //     }
        //     //alert( index + '' + value );
        // });
    },
    goToPage: function(){
        if(window.location.hash && window.location.hash.includes('page')){
            map.currentPage = window.location.hash.slice(-1);
            $('.panels').attr('data-current-page', map.currentPage);
        }
    },
    prevPage: function(){
        console.log('page changed prev');
        map.currentPage = parseInt($('.panels').attr('data-current-page'));
        if(map.currentPage == 1) {
            return;
        }
        map.currentPage--;
        $('.panels').attr('data-current-page', map.currentPage);
        if(history.pushState) {
            history.pushState(null, null, '#page'+map.currentPage);
        } else {
            location.hash = '#page'+map.currentPage;
        }
    },
    nextPage: function(){
        console.log('page changed next');
        map.currentPage = parseInt($('.panels').attr('data-current-page'));
        if(map.currentPage == 5) {
            return;
        }
        map.currentPage++;
        $('.panels').attr('data-current-page', map.currentPage);
        if(history.pushState) {
            history.pushState(null, null, '#page'+map.currentPage);
        } else {
            location.hash = '#page'+map.currentPage;
        }        
    }
}

module.exports = map;